module.exports = __webpack_public_path__ + "static/media/ex-hero2-v2.a991d690.png";